export default {
      id: "oc-projectmapping-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-projectmapping",
      toString: function () {
        return this.url;
      }
    }